import { render, staticRenderFns } from "./BTZDiscount.vue?vue&type=template&id=4f282dde&lang=pug"
import script from "./BTZDiscount.vue?vue&type=script&lang=js"
export * from "./BTZDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports